import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full gap-3',
    image: 'bg-blue-light h-15 w-15',
    content: 'flex w-full flex-col gap-2',
    name: 'flex flex-col',
    additionalInfo: 'flex justify-start gap-6',
    nameText:
      'text-m lg:no-truncate max-w-[218px] truncate leading-[140%] font-semibold text-white lg:max-w-[100%] lg:text-2xl lg:leading-[120%] lg:font-medium lg:whitespace-normal'
  },
  variants: {}
});
